import { render } from "./DosarulAchizitiei.vue?vue&type=template&id=1f808f9d"
import script from "./DosarulAchizitiei.vue?vue&type=script&lang=js"
export * from "./DosarulAchizitiei.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__